<template>
  <base-modal
    :title="$t('modal.confirmDelete.title')"
    :confirmButton="$t('modal.confirmDelete.confirmBtn')"
    confirmButtonColor="red"
    :customShowDialog="showModal"
    @close="$emit('close')"
    @confirmed="handleDeleteConfirmedClick"
  >
    <div slot="body">
      <p class="modal-text" v-html="$t('modal.confirmDelete.text', {fileName: queryName})"></p>
    </div>
  </base-modal>
</template>

<script>
import BaseModal from './BaseModal'
import { deleteQuery } from '@/utils/queries-api'
import { statusEnum } from '@/utils/api-common'

export default {
  name: 'confirm-delete-modal',
  components: {
    BaseModal
  },
  props: ['query', 'showModal'],
  methods: {
    handleDeleteConfirmedClick () {
      this.$emit('close')
      deleteQuery(this.query._id).then(r => {
        if (r.status === statusEnum.error || r.status === statusEnum.notFound) {
          this.$emit('error', this.$t('modal.confirmDelete.cannotDeleteError'))
        } else if (r.status === statusEnum.ok) {
          this.$emit('completed')
        }
      }).catch(r => {
        this.$emit('error', this.$t('modal.confirmDelete.cannotDeleteError'))
        console.warn(r)
      })
    }
  },
  computed: {
    queryName: function () {
      if (this.query) {
        return this.query.name
      } else {
        return ''
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modals/ConfirmDeleteModal.vue